import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

import { SeoTextBlock } from "@faire/retailer/features/Marketplace/components/SeoTextBlock";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
import { LoggedOutCategoryPageWrapper } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/styles/LoggedOutCategoryPageStyles";

export const LoggedOutCategoryPageSeoTextBlock: React.FC = () => {
  const { seoCategoryText } = useLoggedOutCategoryPageMetaTags();
  if (!(seoCategoryText?.text_block || seoCategoryText?.text_block_header)) {
    return null;
  }
  const { text_block, text_block_header } = seoCategoryText;
  return (
    <LoggedOutCategoryPageWrapper>
      <Spacer height="6x" />
      <SeoTextBlock header={text_block_header} content={text_block} />
      <Spacer height="6x" />
    </LoggedOutCategoryPageWrapper>
  );
};
